
<template>
  <div class="Mang">
    <div class="tab_Top">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect_top">
        <el-menu-item index="1">销售线索</el-menu-item>
        <el-menu-item index="2">客户管理</el-menu-item>
        <el-menu-item index="3">订单管理</el-menu-item>
        <el-menu-item index="4">合同管理</el-menu-item>
        <!-- <el-menu-item index="5">数据报表</el-menu-item> -->
      </el-menu>
      <div class="Men_1">
        说明：设置考勤部门与人员、考勤班次、考勤方式（Wi-Fi）等相关规则，点击下方添加考勤进入按步骤设置即可。
      </div>
    </div>
    <div class="tab_Bor"> 
      <div class="T1 bord">
          <el-tooltip class="item" effect="dark" content="线索的来源" placement="top">
          <el-button>线索来源<i class="el-icon-question"></i>:</el-button>
        </el-tooltip>
        <div class="T2">
          <div class="Tuyiiu" @click="Activ(1, 0)" :class="0 == leads_source_value ? 'Actits' : ''">全部</div>
          <div @click="Activ(1 , item.value)" :class="item.value == leads_source_value ? 'Actits' : ''"
                       v-for="item in leads_source" :key="item.value" :label="item.content" :value="item.value">{{item.content}}</div>
          <div @click="AddXs(1)">全部线索类型</div>
        </div>
      </div>

      <div class="T1 bord">
        <el-tooltip class="item" effect="dark" content="线索的需求" placement="top">
          <el-button>线索需求<i class="el-icon-question"></i>:</el-button>
        </el-tooltip>
        <div class="T2">
          <div class="Tuyiiu" @click="Activ(2, 0)" :class="0 == leads_demand_value ? 'Actits' : ''">全部</div>
          <div @click="Activ(2 , item.goods_id)" :class="item.goods_id == leads_demand_value ? 'Actits' : ''" 
              v-for="item in leads_demand" :key="item.goods_id" :label="item.goods_name" :value="item.goods_id">{{item.goods_name}}</div>
        </div>
      </div>
      <div class="T1 bord">
        <el-tooltip class="item" effect="dark" content="线索的价值" placement="top">
          <el-button>线索价值<i class="el-icon-question"></i>:</el-button>
        </el-tooltip>
        <div class="T2">
          <div class="Tuyiiu" @click="Activ(3, 0)" :class="0 == leads_worth_value ? 'Actits' : ''">全部</div>
          <div @click="Activ(3 , item.value)" :class="item.value == leads_worth_value ? 'Actits' : ''" 
            v-for="item in leads_worth" :key="item.value" :label="item.content" :value="item.value">{{item.content}}</div>
          <div @click="AddXs(3)">全部线索价值</div>
        </div>
      </div>
      <div class="T1">
        <el-tooltip class="item" effect="dark" content="创建的时间" placement="top">
          <el-button>创建时间<i class="el-icon-question"></i>:</el-button>
        </el-tooltip>
        <div style="float:left;" class="Topo Tuyiiu">
          <el-date-picker v-model="Months1" type="date" placeholder="选择月份" :clearable="false"></el-date-picker>
          <span style="margin: 0 15px 0 15px;display: inline;">至</span>
          <el-date-picker v-model="Months2" type="date" placeholder="选择月份" :clearable="false"></el-date-picker>
          <div class="Actit" @click="AddXs(4)"  style="margin-left:30px;cursor: pointer;">查询</div>
          <div class="Actit dsdsdsdaaa" @click="AddXs(10)"  style="margin-left:16px;cursor: pointer;">重置</div>
        </div>
      </div>
    </div>

    <div class="Tables ffrrff">
      <div class="T_sele dasdas ddsdaasd" style="width:150px">
          <el-select v-model="type_Self" placeholder="请选择线索" @change="Chang_ses">
              <el-option v-for="item in MMD" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
      </div>
       <div class="Tab_T" @click="AddXs(5)" v-if="TextMoMo('customer:leads:add')" ><img class="Img_ti" src="../../assets/img/+++.png" alt="">创建线索</div>
      <div class="Tab_T Tab_y" @click="export2Excel"  v-if="TextMoMo('customer:leads:claim')"><img class="Img_ti" src="../../assets/img/daochu.png" alt="">导出</div>
      <div class="Tab_T Tab_y" @click="editVisible_DEX = true" v-if="TextMoMo('customer:leads:import')"><img class="Img_ti" src="../../assets/img/daoru.png" alt="">导入</div>
      <div class="Tab_T Tab_y" @click="Add_Del(4)" v-if="TextMoMo('customer:leads:callback')"><img class="Img_ti" src="../../assets/img/tuihui.png" alt="">批量退回</div>
      <div class="Tab_T Tab_y" @click="Add_Del(3)" v-if="TextMoMo('customer:leads:upgrade')"><img class="Img_ti" src="../../assets/img/shengji.png" alt="">批量升级</div>
      <div class="Tab_T Tab_y" @click="Add_Del(1)" v-if="TextMoMo('customer:leads:columns')"><img class="Img_ti" src="../../assets/img/biaoji.png" alt="">批量标记</div>
      <div class="Tab_T Tab_y" @click="Add_Del(5)" v-if="TextMoMo('customer:leads:claim')" ><img class="Img_ti" src="../../assets/img/renling.png" alt="">批量认领</div>
      <div class="Tab_T Tab_y" style="border: 1px solid #FF4D4F;color:#FF4D4F"  @click="Add_Del(2)"><img class="Img_ti" src="../../assets/img/del_p.png" alt="">批量删除</div>
      <div style="margin-top:6px;cursor: pointer;float:left" @click="AddXs(6)" ><i class="el-icon-s-tools"></i></div>
        <div class="el_seso"><i class="el-icon-search" @click="inpu_sech"></i></div>
        <div class="dsds" style="float:right">
          <el-input v-model="input_seach" placeholder="请输入内容" @keyup.enter.native="inpu_sech()"></el-input>
        </div>
        <div v-if="type_Self == 'self'">
          <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            @row-click="handleRowClick"
            header-cell-class-name="table-header"
            @selection-change="handhange">
            <el-table-column
              type="selection"
              width="55"
              align="center"></el-table-column>
            <el-table-column
              prop="id"
              label="ID"
              width="65"
              align="center"></el-table-column>
            <el-table-column align="center" prop="username" label="姓名"></el-table-column>
            <el-table-column align="center" prop="mobile" label="联系方式"></el-table-column>
            <el-table-column align="center" prop="source" label="线索来源"></el-table-column>
            <el-table-column align="center" prop="demand" label="需求项目">
                <template #default="scope" >
                  <div class="elelels" >
                    <span v-for="item in scope.row.goods" :key="item" :label="item" :value="item">{{item}}，</span>
                    <span v-if="scope.row.demand.length > 1">,</span>
                  </div>
                </template>          
            </el-table-column>
            <el-table-column align="center" prop="worth" label="线索价值"></el-table-column>
            <el-table-column align="center" prop="is_contact_text" label="线索状态"></el-table-column>
            <el-table-column align="center" prop="createtime" label="创建时间"></el-table-column>
            <el-table-column align="center" prop="updatetime" label="更新时间"></el-table-column>
            <el-table-column label="操作" align="center" width="300">
              <template #default="scope" >
                  <div class="el_butto" >
                    <el-button type="text" v-if="TextMoMo('customer:leads:read')" @click="Handlbchak(2, scope.row)">查看</el-button>
                    <el-button type="text" v-if="!TextMoMo('customer:leads:read')">查看</el-button>
                  </div>
                  <div class="el_butto" >
                    <el-button type="text" v-if="TextMoMo('customer:leads:edit')" @click="Handlbchak(1, scope.row)">编辑</el-button>
                  </div>
                  <div class="el_butto rere" >
                      <el-button
                      type="text" v-if="TextMoMo('workbench:worknav:nav:add')" 
                      class="red"
                      @click="HanDel(scope.$index, scope.row)"                    
                      >删除</el-button>
                  </div>
                  <div class="Spliiks" style="width: 32%;float: right">
                    <el-dropdown split-button type="primary" @click="handleClick" trigger="click">
                      更多
                      <template #dropdown>  
                        <el-dropdown-menu>
                          <el-dropdown-item v-if="TextMoMo('customer:leads:columns')" >
                            <div class="el_butto dssadd" style="margin:5px 0px 5px 0">  
                              <button @click="Handlbjjt(scope.$index, scope.row)">标记</button>
                            </div>                          
                          </el-dropdown-item>

                          <el-dropdown-item v-if="TextMoMo('customer:leads:upgrade')" >
                            <div class="el_butto dssadd" style="margin:5px 0px 5px 0">
                              <button @click="HanEdit_SJ(scope.$index, scope.row)">升级</button>
                            </div>
                          </el-dropdown-item>

                          <el-dropdown-item v-if="TextMoMo('customer:leads:callback')" >                  
                            <div class="el_butto dssadd" style="margin:5px 0px 5px 0">
                              <button @click="Handlbc_TH(scope.$index, scope.row)">退回</button>
                            </div>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </div>

              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination
              background
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-size="page.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total1">
            </el-pagination>
          </div>
        </div>
        <div v-if="type_Self == 'common'">
          <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handhange">
            <el-table-column
              type="selection"
              width="55"
              align="center"></el-table-column>
            <el-table-column
              prop="id"
              label="ID"
              width="55"
              align="center"></el-table-column>
            <el-table-column prop="username" label="姓名" width="110"></el-table-column>
            <el-table-column prop="mobile" label="联系方式" width="140"></el-table-column>
            <el-table-column prop="source" label="线索来源" width="130"></el-table-column>
            <el-table-column prop="demand" label="需求项目" width="140">
                <template #default="scope" >
                  <div class="elelels" >
                    <span v-for="item in scope.row.demand" :key="item" :label="item" :value="item">{{item}}<span v-if="scope.row.demand.length > 1">,</span></span>
                  </div>
                </template>          
            </el-table-column>
            <el-table-column prop="worth" label="线索价值" width="130"></el-table-column>
            <el-table-column prop="from.realname" label="创建人" width="130"></el-table-column>
            <el-table-column prop="createtime" label="创建时间" width="180"></el-table-column>
            <el-table-column prop="is_contact_text" label="地区" width="170"></el-table-column>
            <el-table-column label="操作" align="center" >  
              <template #default="scope" >
                  <div class="el_butto" style="margin-right:10px">
                    <el-button
                    type="text"
                    @click="HanEdit_SL(scope.$index, scope.row)"
                    >认领</el-button>
                  </div>
                <div class="el_butto rere">
                    <el-button
                    type="text"
                    class="red"
                    @click="HanDel(scope.$index, scope.row)"
                    >删除</el-button>
                </div>

              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination
              background
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-size="page.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total1">
            </el-pagination>
          </div>
        </div>
    </div>

    <!--全部线索管理-->
    <div ref="rightPanel" v-if="show4" class="rightPanel-container show">
      <div class="rightPanel-background"/>
      <div style="width: 345px;position: fixed;top: 0;right: 0;z-index:999;" >
        <el-scrollbar style="height:100%">
          <div class="rightPanel" style="height: 830px;padding-bottom: 120px;">
            <div class="Rig_1">全部线索管理<i class="el-icon-close" @click="Close" style="float:right;padding:20px 50px;cursor: pointer;"></i></div>
            <div class="Rig_A">
              <div class="Rig_D">
                <div class="Rig_Ddd" style="float:left;margin-bottom:8px;width:160px" >每日线索认领量（条）</div>
                <div class="Rig_Rrr" @click="NNNNN(1)">内容管理</div>
                <el-select v-model="ConfigList.claim_day" placeholder="每人每天认领线索上限">
                    <el-option v-for="item in Config1" :key="item.value" :label="item.content" :value="item.content"></el-option>
                </el-select>
              </div>
              <div class="Rig_D">
                <div class="Rig_Ddd" style="float:left;margin-bottom:10px;width:160px">单次线索认领量（条）</div>
                <div class="Rig_Rrr" @click="NNNNN(2)">内容管理</div>
                <el-select v-model="ConfigList.claim_num" placeholder="每人每天认领线索上限">
                    <el-option v-for="item in Config2" :key="item.value" :label="item.content" :value="item.content"></el-option>
                </el-select>
              </div>
              <div class="Rig_D">
                <div class="Rig_Ddd" style="float:left;margin-bottom:10px;width:160px">进程更新对低频（天）</div>
                <div class="Rig_Rrr" @click="NNNNN(3)">内容管理</div>
                <el-select v-model="ConfigList.claim_one" placeholder="低于设置时间将回收销售线索">
                    <el-option v-for="item in Config3" :key="item.value" :label="item.content" :value="item.content"></el-option>
                </el-select>
              </div>
              <div class="Rig_D">
                <div class="Rig_Ddd" style="float:left;margin-bottom:10px;width:160px">每周数据导出频率（次）</div>
                <div class="Rig_Rrr" @click="NNNNN(4)">内容管理</div>
                <el-select v-model="ConfigList.export_one" placeholder="每周每人可以带出数据次数">
                    <el-option v-for="item in Config4" :key="item.value" :label="item.content" :value="item.content"></el-option>
                </el-select>
              </div>
              <div class="Rig_D">
                <div class="Rig_Ddd" style="float:left;margin-bottom:10px;width:160px">每次数据导出数量（条）</div>
                <div class="Rig_Rrr" @click="NNNNN(5)">内容管理</div>
                <el-select v-model="ConfigList.export_week" placeholder="每人每次可以导出数量的上限">
                    <el-option v-for="item in Config5" :key="item.value" :label="item.content" :value="item.content"></el-option>
                </el-select>
              </div>
              <div class="Rig_D">
                <div class="Rig_Ddd" style="float:left;margin-bottom:10px;width:160px">认领权限设置</div>
                <div class="Rig_Rrr" @click="NNNNN(6)">内容管理</div>
                <el-select v-model="ConfigList.flow_min" placeholder="同一人认领同一线索次数">
                    <el-option v-for="item in Config6" :key="item.value" :label="item.content" :value="item.content"></el-option>
                </el-select>
                
              </div>
              
              <div class="BCSZ" style="margin-right:24px" @click="Btn_Xsxs">确定</div>
              <div class="BCSZ" @click="show4 = false" style="background:#fff;color:#595959;border: 1px solid #D9D9D9;">取消</div>
              
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <!--全部线索管理-->

    <!--添加线索来源-->
    <el-dialog title="添加线索来源" v-model="dialogVisible3" width="36%">
      <div class="Tabbl">
        <el-table
        :data="Categ"
        class="table"
        header-cell-class-name="table-header"
        @selection-change="handleSelectionChange">
        <el-table-column label="线索类型" width="240" align="center" >
          <template #default="scope" >
              <div class="El_pop dasdasd">
                <el-input :disabled = "scope.row.type == 'default' ? true : false"  v-model="scope.row.content" placeholder="类别"></el-input>
              </div>
          </template>
        </el-table-column>
        <el-table-column label="设置" width="180" align="center">
            <template #default="scope">
            <div v-if="scope.row.type == 'default'">预设</div>
            <div v-if="scope.row.type == 'custom'">自定义</div>
            </template>
        </el-table-column>
        <el-table-column label="是否启用" width="100">
          <template #default="scope" >
            <div class="el_butto rere dsdtrt">
                <el-switch
                
                  :disabled="scope.row.type == 'default' ? true : false "
                  v-model="scope.row.status"
                  active-value = 'normal'
                  inactive-value = 'hidden'
                  active-color="#1890FF"
                  @change="changeSwitch($event,scope.row,scope.$index)"
                  inactive-color="#dcdfe6">
                </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" >
          <template #default="scope" >
            <div class="el_butto rere dsdtrt">
                <i class="el-icon-delete" @click="haeDete(scope.$index, scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="Y_ids" @click="Add_leibie"><i class="el-icon-plus"></i>创建内容</div>
      <div class="Dityo">
        <div class="dialog-footer">
          <el-button @click="dialogVisible3 = false">取 消</el-button>
          <el-button type="primary" @click="NabCH_BTN()">确 定</el-button>
        </div>
      </div>  

    </el-dialog>
    <!--添加线索来源-->

    <!--全部线索类型管理-->
    <el-dialog title="全部线索类型管理" v-model="dialogVisible2" width="36%">
      <div class="Tabbl">
        <el-table
        :data="Categ2"
        class="table"
        header-cell-class-name="table-header"
        @selection-change="handleSelectionChange">
        <el-table-column label="线索类型" width="240" align="center" >
          <template #default="scope" >
              <div class="El_pop dasdasd">
                <el-input type="number" :disabled = "scope.row.type == 'default' ? true : false"  v-model="scope.row.content" placeholder="类别"></el-input>
              </div>
          </template>
        </el-table-column>
        <el-table-column label="设置" width="180" align="center">
            <template #default="scope">
            <div v-if="scope.row.type == 'default'">预设</div>
            <div v-if="scope.row.type == 'custom'">自定义</div>
            </template>
        </el-table-column>
        <el-table-column label="是否启用" width="100">
          <template #default="scope" >
            <div class="el_butto rere dsdtrt">
                <el-switch
                
                  :disabled="scope.row.type == 'default' ? true : false "
                  v-model="scope.row.status"
                  active-value = 'normal'
                  inactive-value = 'hidden'
                  active-color="#1890FF"
                  @change="changeSwitch($event,scope.row,scope.$index)"
                  inactive-color="#dcdfe6">
                </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" >
          <template #default="scope" >
            <div class="el_butto rere dsdtrt">
                <i class="el-icon-delete" @click="haeDete2(scope.$index, scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="Y_ids" @click="Add_leibie2"><i class="el-icon-plus"></i>创建内容</div>
      <div class="Dityo">
        <div class="dialog-footer" style="margin-bottom:20px">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="NabCH_BTN2()">确 定</el-button>
        </div>
      </div>  

    </el-dialog>
    <!--全部线索类型管理-->

    <!-- 身份升级 -->
    <el-dialog title="身份升级" v-model="editVisible" width="30%" class="">
      
        <el-form ref="form" label-width="100px">
          <div class="DDGGD">
          <el-form-item label="姓名：">
            <el-input v-model="TA_name1" disabled></el-input>
          </el-form-item>
          <el-form-item label="目前身份：">
            <el-input v-model="TA_name2" disabled></el-input>
          </el-form-item>
          <el-form-item label="升级到：">
            <div class="rasdas">
              <el-select v-model="Customer_Self" placeholder="请选择线索" style="width: 100%;">
                  <el-option v-for="item in Customer_worth" :key="item.value" :label="item.content" :value="item.value"></el-option>
              </el-select>
              <!-- <span class="El_dsds">客户管理</span> -->
            </div>

          </el-form-item>
          </div>
        </el-form>
        <template #footer>
          <span class="dialog-footer" style="margin-bottom:28px">
            <el-button @click="editVisible = false" style="margin-right:15px">取 消</el-button>
            <el-button type="primary" v-if="Ta_Shsh == 0" @click="saveEdit(2)">确 认</el-button>
            <el-button type="primary" v-if="Ta_Shsh == 1" @click="saveEdit(1)">确 认</el-button>
          </span>
        </template>
      

    </el-dialog>
    <!-- 身份升级 -->

    <!-- 导入 -->
    <el-dialog title="导入文件" v-model="editVisible_DEX" width="31%" class="">
        <el-form ref="form" label-width="120px">
          <div class="DDGGD">
          <el-form-item label="模板：">
             <el-button type="primary"> <a style="color:#fff" href="./w3school_logo.xlsx" download="w3school_logo.xlsx">下载模板</a></el-button>
          </el-form-item>
          <el-form-item label="选择导入文件：" style="margin-bottom:5px">
            <div class="el-form-item__content">
              <el-upload
                  accept=".xls,.xlsx"
                  :action="upload"
                  :headers="heads"
                  :multiple="false"
                  :file-list="fileList"
                  :on-success="UP_Success3"
                  :on-remove="fileRemove">
                  <el-button size="small" type="primary">选择文件</el-button>
                  <div class="el-upload__tip">一次只能上传一个xls/xlsx文件，且不超过10M</div>
              </el-upload>

          </div>
          </el-form-item>
          <el-form-item label="可见员工：">
            <div class="Rtty Riiiu">
              <el-select v-model="File_Yid" multiple placeholder="请选择可见员工">
                  <el-option v-for="item in StaFFList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="可见部门：">
            <div class="Rtty Riiiu">
              <el-cascader
                :options="DementList"
                v-model="File_Bid"
                :props="{ multiple: true, checkStrictly: true, label : 'name', value: 'id'}"
                @change="Handmuiksd2"
                clearable
              ></el-cascader>
            </div>
          </el-form-item>
          </div>
        </el-form>
        <template #footer>
          <span class="dialog-footer" style="margin-bottom:28px">
            <el-button @click="editVisible_DEX = false" style="margin-right:15px">取 消</el-button>
            <el-button type="primary" @click="File_Sure()">确 认</el-button>
          </span>
        </template>
      

    </el-dialog>
    <!-- 导入 -->

    <!-- 创建线索 -->
    <div ref="rightPanel" v-if="show1" class="rightPanel-container show">
          <div class="rightPanel-background"/>
          <div style="height:1100px;width: 656px;position: fixed;top: 0;right: 0;z-index:999;" >
            <el-scrollbar style="height:100%">
              <div class="rightPanel">
                <div class="Rig_1" v-if="chakan111 == 1">创建线索<i class="el-icon-close" @click="show1 = false"  style="float:right;padding:20px 50px;cursor: pointer;"></i></div>
                <div class="Rig_1" v-if="chakan111 == 0">查看线索<i class="el-icon-close" @click="show1 = false"  style="float:right;padding:20px 50px;cursor: pointer;"></i></div>
                <div style="margin:0 0 18px 24px " v-if="chakan111 == 0">
                  <el-menu
                    :default-active="acndex"
                    class="el-menu-demo"
                    mode="horizontal"
                    @select="handleSelect">
                    <el-menu-item index="1">线索信息</el-menu-item>
                    <el-menu-item index="2">线索记录</el-menu-item>
                  </el-menu>
                </div>
                
                <div class="Rig_A" v-if="info_Show == 0">
                    <div class="Diidd_Yi">
                        <div class="Yiiiuyt2">
                            <div class="Rig_D">
                                <div class="Rig_Ddd"> 
                                  <span style="color:#FF4D4F">* </span>姓名：</div>
                                <div class="Rtty">
                                <el-input v-model="valueA_input1" placeholder="请输入姓名" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="Yiiiuyt2">
                            <div class="Rig_D">
                                <div class="Rig_Ddd"><span style="color:#FF4D4F">* </span> 联系方式：</div>
                                <div class="Rtty">
                                <el-input v-model="valueA_input2" placeholder="请输入联系方式" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="Yiiiuyt2">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 需求来源：</div>
                                <el-select v-model="valueA_1" placeholder="请选择需求来源">
                                  <el-option v-for="item in leads_source" :key="item.value" :label="item.content" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="Yiiiuyt2">
                            <div class="Rig_D ">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 需求价值：</div>
                                <el-select v-model="valueA_2" placeholder="请选择需求价值">
                                    <el-option v-for="item in leads_worth" :key="item.value" :label="item.content" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <div class="Rig_D Tigtgg" style="width:95%">
                      <div class="Rig_Ddd" >需求项目：</div>
                      <div class="Rtty" style="clear:both">
                        <el-select v-model="valueA_3" multiple placeholder="请选择需求项目" @change="changeRTY" >
                            <el-option v-for="item in leads_demand" :key="item.goods_id" :label="item.goods_name" :value="item.goods_id"></el-option>
                        </el-select>
                      </div>
                    </div> 
                    <div class="Rig_D Tigtgg" v-if="type_Self == 'common'">
                      <div class="Rig_Ddd" >可见员工：</div>
                      <div class="Rtty" style="clear:both">
                        <el-select v-model="valueA_4" multiple placeholder="请选择可见员工">
                            <el-option v-for="item in StaFFList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
                        </el-select>
                      </div>
                    </div> 
                    <div class="Rig_D Tigtgg" v-if="type_Self == 'common'">
                      <div class="Rig_Ddd" >可见部门：</div>
                      <div class="Rtty" style="clear:both">
                        <el-cascader
                          :options="DementList"     
                          v-model="Case_attse"
                          :props="{ multiple: true, checkStrictly: true, label : 'name', value: 'id'}"
                          @change="Handmuiksd"
                          clearable
                        ></el-cascader>
                      </div>
                    </div> 
                    <div class="Rig_D" style="width: 100%;">
                        <div class="Rig_Ddd" >描述（选填）：</div>
                        <div class="Rtty">
                            <el-input type="textarea" v-model="valueA_input3" placeholder="可以将线索用户的一些具体特征或者条件如实的写下来，方便员工更好的了解此线索" ></el-input>           
                        </div>
                    </div>
                    <div>
                      <div class="Rig_Ddd" style="margin-bottom:19px;float:none">图片线索（选填）</div>
                      <div class="Rtty" style="clear:both;display: flex;">
                  
                        <img class="Rtt_im22g" v-for="item in full_avatar" :key="item" :label="item" :value="item" :src="item" />
                        <div >
                          <el-upload
                            :action="upload"
                            :headers="heads"
                            list-type="picture-card"
                            :on-success="UP_Success"
                            :on-remove="HAndemove"
                            :on-preview="handlePictureCardPreview">
                            <i class="el-icon-plus"></i>
                            <div class="el_asff">上传图片</div>
                          </el-upload>
                        </div>
                      </div>
                    </div>
                    <div class="BCSZ" style="margin-right:24px;" @click="Btn_cj(1)" v-if="type_Self == 'self'">保存设置</div>
                    <div class="BCSZ" style="margin-right:24px;" @click="Btn_cj(2)" v-if="type_Self == 'common'">保存设置</div>
                    <div class="BCSZ" style="background:#fff;color:#595959;border: 1px solid #D9D9D9;" @click="show1 = false">取消</div>
                </div>
                <div v-if="info_Show == 1">
                    <div class="Rig_A">
                      <div class="Rig_D Tigtgg R_texxt" style="width: 100%;">
                        <div class="TRRE">
                          <div style="margin:8px 0 9px 0;font-size: 14px;color: #333333;">全部进程信息</div>
                          <div style="margin:20px 24px 0 1px;" v-if="Flow_list.length != 0">
                              <el-scrollbar height="100%">
                                <div id="time-line">
                                  <div class="item" v-for="item in Flow_list" :key="item.index">
                                    <div class="ytyt">
                                      <div class="item-index">{{ item.createtime }}</div>
                                      <div class="item-content">{{ item.info }}</div>
                                      <img class="Rtt_im22g" v-for="item in item.imgs_url" :key="item" :label="item" :value="item" :src="item"   />
                                    </div>
                                  </div>
                                </div>
                              </el-scrollbar>
                          </div>
                          <div v-if="Flow_list.length == 0" style="font-size: 14px;color: rgb(51, 51, 51);margin-top:20px">
                            暂无信息
                          </div>
                        </div>
                        <div class="Rig_D" style="position: relative;width:100%">
                            <div class="Rig_Ddd" style="margin-bottom:9px;margin-top:30px"> <span style="color:#FF4D4F">*</span> 文字记录</div>
                            <div class="Rtty">
                                <el-input type="textarea" style="" v-model="Info_desc" 
                                placeholder="请将每次沟通、维护、跟单、咨询等相关信息记录在这里，为了提高效率
① 选择常用语更新记录
② 手动输入文字信息
③ 将重要的凭证、历史沟通、其他社交媒体截图等在下方上传保存"></el-input>           
                            </div>     
                          <div class="Rtty Riuo fdgfg" style="clear:both;">
                            <!-- <el-select v-model="valueA_input1" placeholder="请选择常用语">
                                <el-option v-for="item in valueA_input1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select> -->
                            <div style="margin:4px 23px 0 0;float:right">
                                <el-checkbox v-model="valueA_input1" label="同步给客户"></el-checkbox>
                            </div>
                          </div>
                        </div>  
                        <div>
                          <div class="Rig_Ddd" style="margin:28px 0 19px 0">图片线索（选填）</div>
                          <div class="Rtty TUUu" style="clear:both">
                              <!-- <img class="Rtt_im22g" v-for="item in full_avatar" :key="item" :label="item" :value="item" :src="item"   /> -->
                              <div style="margin-top:20px">
                                <el-upload
                                  :action="upload"
                                  :headers="heads"
                                  list-type="picture-card"
                                  :on-success="UP_Success2"
                                  :on-remove="HAndemove2"
                                  :on-preview="handlePictureCardPreview">
                                  <i class="el-icon-plus"></i>
                                  <div class="el_asff">上传图片</div>
                                </el-upload>
                              </div>
                          </div>
                        </div>

                        <div class="Rtty">
                            <div class="BCSZ" style="margin-right:24px" @click="Btn_dsa">保存设置</div>
                            <div class="BCSZ" @click="show1 = false" style="background:#fff;color:#595959;border: 1px solid #D9D9D9;">取  消</div>
                        </div>
                      </div> 

                    </div>
                
                </div>
              </div>
            </el-scrollbar>
          </div>
    </div>
    <!-- 创建线索 -->

   <!-- 创建线索 -->
    <div ref="rightPanel" v-if="show11" class="rightPanel-container show">
          <div class="rightPanel-background"/>
          <div style="height:1100px;width: 656px;position: fixed;top: 0;right: 0;z-index:999;" >
            <el-scrollbar style="height:100%">
              <div class="rightPanel">
                <div class="Rig_1">查看线索<i class="el-icon-close" @click="show11 = false"  style="float:right;padding:20px 50px;cursor: pointer;"></i></div>
                <div class="Rig_A">
                    <div style="overflow:hidden">
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd"> 
                                  <span style="color:#FF4D4F">* </span>姓名：</div>
                                <div class="Rtty">
                                <el-input v-model="valueA_input1" placeholder="请输入姓名" class="El_ii" disabled></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd"><span style="color:#FF4D4F">* </span> 联系方式：</div>
                                <div class="Rtty">
                                <el-input v-model="valueA_input2" placeholder="请输入联系方式" class="El_ii" disabled></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="overflow:hidden">
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 需求来源：</div>
                                <el-select v-model="valueA_1" placeholder="请选择需求来源" disabled>
                                  <el-option v-for="item in leads_source" :key="item.value" :label="item.content" :value="item.value" ></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="width:50%;float:left">
                            <div class="Rig_D ">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 需求价值：</div>
                                <el-select v-model="valueA_2" placeholder="请选择需求价值" disabled>
                                    <el-option v-for="item in leads_worth" :key="item.value" :label="item.content" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <div class="Rig_D Tigtgg" style="width: 95%;">
                      <div class="Rig_Ddd" >需求项目：</div>
                      <div class="Rtty" style="clear:both">
                        <el-select v-model="valueA_3" multiple placeholder="请选择需求项目" @change="changeRTY" disabled >
                            <el-option v-for="item in leads_demand" :key="item.goods_id" :label="item.goods_name" :value="item.goods_id"></el-option>
                        </el-select>
                      </div>
                    </div> 
                    <div class="Rig_D Tigtgg" v-if="type_Self == 'common'">
                      <div class="Rig_Ddd" >可见员工：</div>
                      <div class="Rtty" style="clear:both">
                        <el-select v-model="valueA_4" multiple placeholder="请选择可见员工" disabled>
                            <el-option v-for="item in StaFFList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
                        </el-select>
                      </div>
                    </div> 
                    <div class="Rig_D Tigtgg" v-if="type_Self == 'common'">
                      <div class="Rig_Ddd" >可见部门：</div>
                      <div class="Rtty" style="clear:both">
                        <el-cascader 
                          :options="DementList"     
                          v-model="Case_attse" disabled
                          :props="{ multiple: true, checkStrictly: true, label : 'name', value: 'id'}"
                          @change="Handmuiksd"
                          clearable
                        ></el-cascader>
                      </div>
                    </div> 
                    <div class="Rig_D" style="width: 100%;">
                        <div class="Rig_Ddd" >描述（选填）：</div>
                        <div class="Rtty">
                            <el-input type="textarea" v-model="valueA_input3" disabled placeholder="可以将线索用户的一些具体特征或者条件如实的写下来，方便员工更好的了解此线索" ></el-input>           
                        </div>
                    </div>
                    <div>
                      <div class="Rig_Ddd" style="margin-bottom:19px;float:none">图片线索（选填）</div>
                      <div class="Rtty" style="clear:both" >
                        <img class="Rtt_im22g" v-for="item in full_avatar" :key="item" :label="item" :value="item" :src="item" />
                      </div>
                    </div>
                    <div class="BCSZ" style="background:#fff;color:#595959;border: 1px solid #D9D9D9;margin-right: 30px;" @click="show11 = false">取消</div>
                </div>
  
              </div>
            </el-scrollbar>
          </div>
    </div>
    <!-- 创建线索 -->
  </div>
</template>

<script>
import axios from 'axios'
import { fetchData } from "../../api/index";
import  TextMoth  from "../../components/utils.vue";
export default {
  name: "basetable",
  data() {
    return {
      tableData1: [{
          id: '2021-07-09',
          num: '452156165156',
          pay: '公司注册地址',
          fuwus: '张老师',
          zhifu: '微信',
          order:'已购买',
          jine:'1221.00'
        }, {
          id: '2021-07-09',
          num: '452156165156',
          pay: '公司注册地址',
          fuwus: '张老师',
          zhifu: '微信',
          order:'已购买',
          jine:'1221.00'
        }, {
          id: '2021-07-09',
          num: '452156165156',
          pay: '公司注册地址',
          fuwus: '张老师',
          zhifu: '微信',
          order:'已购买',
          jine:'1221.00'
        }, {
          id: '2021-07-09',
          num: '452156165156',
          pay: '公司注册地址',
          fuwus: '张老师',
          zhifu: '支付宝呵呵',
          order:'已购买',
          jine:'1221.00'
      }],
      tableData2: [
        {
            id:'2021-07-26 10:05',
            name:'职称登记表。pdf',
            amount2:'1.2M',

        },
        {
            id:'2021-07-26 10:05',
            name:'职称登记表。pdf',
            amount2:'1.2M',
        },
        {
            id:'2021-07-26 10:05',
            name:'职称登记表。pdf',
            amount2:'1.2M',
        },
    ],
      TA_name1:'',
      TA_name1_Arr:[],
      TA_name2:'销售线索',
      TA_name3:'',
      Show:false,
      Inpup:'',
      reverse: true,

      Flow_list:[],
      
      info_Show:0 ,
      checked_kehu:false,
      activeIndex: '1',
      acndex:'1',
      dialogImageUrl: '',
      radio:'1',

      show1:false,
      show11:false,
      show4: false,
      editVisible_DEX:false,
      dialogVisible2: false,  
      dialogVisible3: false,  
      dialogVisible4: false,

      
      multipleSelection_id:null,   //勾选的信息
      multipleSelection:[],
      Ta_Shsh:0,

      tableData: [],
      total1:0,
      total2:0,
      currentPage1:0,
      currentPage2:0,

      idW:0,
      idY:0,
      idG:0,

      Categ:[],
      Categ2:[],
      input_seach:'',
      type_Self: 'self',
      dialogVisible3_e:0,
      dialogVisible2_e:0,

      Config1:[],
      Config2:[],
      Config3:[],
      Config4:[],
      Config5:[],
      Config6:[],
      leads_source:[],  //线索来源
      leads_source_W:[],  //线索来源
      leads_source_id:0,  //线索来源
      leads_source_value:0,

      leads_demand:[],  //线索需求
      leads_demand_W:[],  //线索需求
      leads_demand_id:0,  //线索需求
      leads_demand_value:0,  //线索需求

      leads_worth:[],  //线索价值
      leads_worth_W:[],  //线索价值
      leads_worth_id:0,  //线索价值
      leads_worth_value:0,  //线索价值
      Months1:'',
      Months2:'',

      se_id:0,
      wo_id:0,
      de_id:0,

      valueA_1:'',
      valueA_2:'',
      valueA_3:'',
      valueA_4:'',
      valueA_5: [],
      Case_attse:[],  //可见部门
      chakan111:0,
      Hand_id:0,

      valueA_input1:'',
      valueA_input2:'',
      valueA_input3:'',
      Row_Eurl:[],          //图片
      Row_Eurl2:[],          //图片
      Info_desc:'',
      Claim:{},

      File:'',
      File_Yid:[],
      File_Bid:[],
      fileList:[],

      upload:'https://rest-api.duxin365.com/admin/ajax/upload',
      upload2:'https://rest-api.duxin365.com/admin/ajax/upload',
      heads:{token:''},

      MMD:[{id:'self',name:'我的线索'},{id:'common',name:'全部线索'}],
      MMD_detail:{},
      editVisible:false,
      Customer_worth:[],
      Customer_Self:'',
      StaFFList:[],    ///////////// 全部员工列表
      DementList:[],   ////////////  全部部门列表

      fForm:{},
      ConfigList:{}
    };
  },
  mounted() {
    var that = this

    let token = window.localStorage.getItem("accessToken")
    that.heads.token = token
    axios.get('/admin/ajax/staffList',{   // 全部员工列表
        }).then(function (res) {
          if (res.data.code == 0) {
            alert('请求失败');  
          } else{ 
              that.StaFFList = res.data.data
          }
    })  
    axios.get('/admin/company/department/index',{   // 全部部门列表
      }).then(function (res) {
        if (res.data.code == 0) {
          alert('请求失败');  
        } else{ 
          that.DementList = res.data.data.rows
        }
    })
    axios({ method: 'post', url: '/admin/ajax/goodsList', 
        }).then(function (res) {
          if(res.data.code == 0) {
          } else {
            that.leads_demand = res.data.data
            console.log(that.leads_demand)
            that.leads_demand_W = res.data.data.slice()   //复制一个数组
            that.leads_demand_value = 0
          }
    })
    axios.get('/admin/customer/leads/statisticsColumns',{ 
      }).then(function (res) {
        if (res.data.code == 401) {
            // that.$router.push('/Login');
        } else{
          that.leads_source = res.data.data.leads_source
          that.leads_source_W = res.data.data.leads_source.slice()
          that.leads_source_value = 0

          that.leads_worth = res.data.data.leads_worth
          that.leads_worth_W = res.data.data.leads_worth.slice()
          that.leads_worth_value = 0
      }
    })  
    that.AAAAA()
    axios.get('/admin/customer/customer/statisticsColumns',{
      }).then(function (res) {
        if (res.data.code == 401) {
            // that.$router.push('/Login');
        } else{
          that.Customer_worth = res.data.data.customer_worth
      }
    })  
    axios.get('/admin/customer/config/index',{   // 全部部门列表
            params:{
              type: 'leads'
            }
      }).then(function (res) {
        if (res.data.code == 0) {
          alert('请求失败');  
        } else{ 
          that.ConfigList = res.data.data.config
        }
    })  
  },
  methods: {
    TextMoMo(e) {
      var arr = TextMoth.getData(e)
      return arr  
    },
    handleRowClick(row, column, event){
          this.$refs.multipleTable.toggleRowSelection(row);
    },

    export2Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../excel/Export2Excel');
        const tHeader = ['姓名', '联系方式', '线索来源', '需求项目' , '线索价值', '创建人', '创建时间', '地区'];
        // 上面设置Excel的表格第一行的标题
        const filterVal = ['username', 'mobile', 'source', 'demand', 'worth', 'realname', 'createtime', 'is_contact_text'];
        // 上面的index、nickName、name是tableData里对象的属性
        const list = this.tableData;  //把data里的tableData存到list
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '销售线索');
      })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    beforeUpload(file) {                             // 上传文件之前的钩子：判断上传文件格式、大小等，若返回false则停止上传
        //文件类型
        const isType = file.type === 'application/vnd.ms-excel'
        const isTypeComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        const fileType = isType || isTypeComputer
        if(!fileType) {
            this.$message.error('上传文件只能是xls/xlsx格式！')
        }

        // 文件大小限制为10M
        const fileLimit = file.size / 1024 / 1024 < 10;
        if(!fileLimit) {
            this.$message.error('上传文件大小不超过10M！');
        }
        return fileType && fileLimit
    },
    File_Sure(e) {
      var that = this
      var arr = []
      var acc = []

      axios({
          method: 'post',
          url: '/admin/customer/leads/import', 
          data: {
            file:that.File,
            power:{
              staff_ids:that.File_Yid,
              department_ids:that.valueA_5
            }
          },
        }).then(function (res) {
          if(res.data.code == 0) {
            that.$message.warning(res.data.msg);
          } else {
              that.$message.success(res.data.msg);
              that.editVisible_DEX = false
          }
        })       
    },
    UP_Success3(e) {                //图片上传成功
      var that = this
      console.log(e)
      that.File = e.data.url
      that.aTY = 0
      console.log(that.File)
    },
    fileRemove(file, fileList) {                    // 移除选择的文件
        if(fileList.length < 1) {
            this.uploadDisabled = true //未选择文件则禁用上传按钮
        }
        console.log(file)
    },
    changeRTY(e) {
      var that = this
      console.log(e)
      console.log(that.valueA_3)
    },
    Handlbchak(e,data) {
      var that = this
      that.Hand_id = data.id
      
      if (e == 1) {
        that.info_Show = 0
        that.acndex = 1
        that.show1 = true
      } else if( e== 2 ){
        that.show11 = true
      }
      axios.get('/admin/customer/leads/read',{   // 线索详情
            params:{
              id: data.id
            }
        }).then(function (res) {
          console.log(res.data.data);
          if (res.data.code == 0) {
            alert('请求失败');  
          } else { 
            that.valueA_input1 = res.data.data.row.username
            that.valueA_input2 = res.data.data.row.mobile
            that.valueA_input3 = res.data.data.row.description
            that.valueA_1 = res.data.data.row.source_id
            that.valueA_2 = res.data.data.row.worth_id

            var arr = res.data.data.row.goods_obj
            console.log(arr)
            var acc = []
            for (let i = 0; i < arr.length; i++) {
               acc.push(parseInt(arr[i]));
            }

            that.valueA_3 = acc
            console.log(acc)
            console.log(that.valueA_3)
            that.full_avatar = res.data.data.row.imgs_url
            that.Row_Eurl = res.data.data.row.images
          }
      })
      axios.get('/admin/customer/flow/read',{   // 线索 进程信息
            params:{
              leads_id: data.id
            }
        }).then(function (res) {
          if (res.data.code == 0) {
            alert('请求失败');  
          } else { 
            that.Flow_list = res.data.data.flow_list
          }
      }) 
    },
    Close() {
      this.dialogVisible3 = false;
      this.dialogVisible4 = false;
      this.dialogVisible5 = false;
      this.show1 = false;
      this.show11 = false;
      this.show4 = false;
    },
    TJ2() {
      this.dialogVisible7 = true;
    },

    submitUpload() {
      this.$refs.upload.submit();
    },
    Btn_dsa() {                     //  进程提交
      var that = this
      axios({
          method: 'post',
          url: '/admin/customer/flow/add', 
          data: {
            row:{
              leads_id: that.Hand_id, //线索ID，销售线索时必填
              info: that.Info_desc, //进程的信息
              type: "leads", //类型:leads=线索,customer=客户,order=订单,contract=合同
              source_id: that.Hand_id, //当前类型所在列表ID
              images: that.Row_Eurl2
            }
          },
        }).then(function (res) {
          if(res.data.code == 0) {
            that.$message.warning(res.data.msg);
          } else {
              that.$message.success(res.data.msg);
              axios.get('/admin/customer/flow/read',{   // 线索 进程信息
                params:{
                  leads_id: that.Hand_id
                }
              }).then(function (res) {
                if (res.data.code == 0) {
                  alert('请求失败');  
                } else { 
                  that.Flow_list = res.data.data.flow_list
                  that.Info_desc = ''
                }
            }) 
          }
          
        })       
    },
    Btn_Xsxs(e) {                   //全部线索管理 确认
      var that = this
        axios({
          method: 'post',
          url: '/admin/customer/config/edit', 
          data: {
            row:{
              leads:that.ConfigList
            }

          },
        }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.$message.success(res.data.msg);
                that.show4 = false
                that.AAAAA()
              }
        })      
    },
    AddXs(e) {     // 点击全部线索类型
       var that = this
       that.dialogVisible3_e = e
       let y1 =''
       let y2 =''
       
       if(that.Months1 != '') {
         y1 = that.formatDate(that.Months1);
       }
       if(that.Months2 != '') {
         y2 = that.formatDate(that.Months2);
       }
      
      if (e == 1) {
        that.dialogVisible3 = true
        that.Categ = that.leads_source_W
      } else if (e == 2) {
        that.dialogVisible3 = true
        that.Categ = that.leads_demand_W
      } else if (e == 3) {
        that.dialogVisible3 = true
        that.Categ = that.leads_worth_W
      } else if (e == 4) {
        // that.dialogVisible3 = true
        axios({
          method: 'post',
          url: '/admin/customer/leads/index', 
          data: {
            page: 1,
            offset:0,
            limit:8,
            type: that.type_Self,
            filter:{
              source_id: that.se_id,
              worth_id: that.wo_id,
              demand_id: that.de_id,
              time:{
                min:y1,
                max:y2,
              },
              keyword:that.input_seach
            }
          },
        }).then(function (res) {
          that.tableData = res.data.data.rows
          that.total1 = res.data.data.total
        })
      } else if (e == 5) {
          that.chakan111 = 1
          that.show1 = true
          that.valueA_1='',
          that.valueA_2='',
          that.valueA_3='',
          that.valueA_input1='',
          that.valueA_input2='',
          that.valueA_input3='',
          that.Row_Eurl=[]      
          that.full_avatar=[]      
      } else if (e == 6) {
        that.show4 = true;
        that.BBBBB()
      } else if(e == 10) {
        that.Months1 = ''
        that.Months2 = ''
      }
    },
    NNNNN(e){         //内容管理
      var that = this
      that.dialogVisible2 = true
      that.dialogVisible2_e = e
      
      axios.get('/admin/customer/config/statisticsColumns',{   // 设置选项 
            params:{
              type: 'leads'
            }
        }).then(function (res) {
          if (res.data.code == 0) {
            alert('请求失败');  
          } else{ 
              that.Claim = res.data.data
              if (e == 1) {
                that.Categ2 = res.data.data.claim_day
                that.Config1 = res.data.data.claim_day
              } else if(e == 2) {
                that.Categ2 = res.data.data.claim_one
                that.Config2 = res.data.data.claim_one
              } else if(e == 3) {
                that.Categ2 = res.data.data.flow_min
                that.Config3 = res.data.data.flow_min
              } else if(e == 4) {
                that.Categ2 = res.data.data.export_week
                that.Config4 = res.data.data.export_week
              } else if(e == 5) {
                that.Categ2 = res.data.data.export_one
                that.Config5 = res.data.data.export_one
              } else if(e == 6) {
                that.Categ2 = res.data.data.claim_num
                that.Config6 = res.data.data.claim_num
              }
          }
      })  

    },
    Activ(e, id) {
      console.log(e)
      console.log(id)
      var that = this
      if (e == 1) {
        that.leads_source_value = id
        that.se_id = id
      } else if (e == 2) {
        that.leads_demand_value = id
        that.wo_id = id
      } else if (e == 3) {
        that.de_id =id
        that.leads_worth_value = id
      }
        let y1 =''
        let y2 =''
       
       if(that.Months1 != '') {
         y1 = that.formatDate(that.Months1);
       }
       if(that.Months2 != '') {
         y2 = that.formatDate(that.Months2);
       }

      axios({
        method: 'post',
        url: '/admin/customer/leads/index', 
        data: {
          page: 1,
          offset:0,
          limit:8,
          type: that.type_Self,
          filter:{
            source_id: that.se_id,
            worth_id: that.de_id,
            demand_id: that.wo_id,
            time:{
              min:y1,
              max:y2,
            },
            keyword:that.input_seach
          }
        },
      }).then(function (res) {
       that.tableData = res.data.data.rows
       that.total1 = res.data.data.total
      }) 
    },
    Add_leibie() {            //创建导航类别
      var that = this
      var ATT = that.Categ
      var srt = {
        content: "新加",
        status: 'normal',
        type: "custom",
        value:0,
      }
      ATT.push(srt)
      that.Categ = ATT
    },  
    Add_leibie2() {            //创建导航类别    --------------全部线索管理
      var that = this
      var ATT = that.Categ2
      var srt = {
        content: "10",
        status: 'normal',
        type: "custom",
        value:0,
      }
      ATT.push(srt)
      that.Categ2 = ATT
    }, 
    NabCH_BTN() {             // 导航确认
        var that = this 
        var ATT = that.Categ
        if (that.dialogVisible3_e == 1) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_source", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible3 = false
                that.Columns()
              }
          })  
        } else if(that.dialogVisible3_e == 2) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_demand", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible3 = false
                that.Columns()
              }
          })            

        } else if(that.dialogVisible3_e == 3) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_worth", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible3 = false
                that.Columns()
              }
          })  
        }
     
    },
    NabCH_BTN2() {             // 导航确认         --------------全部线索管理
        var that = this 
        var ATT = that.Categ2
        if (that.dialogVisible2_e == 1) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_claim_day", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        } else if (that.dialogVisible2_e == 2) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_claim_one", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        } else if (that.dialogVisible2_e == 3) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_flow_min", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        } else if (that.dialogVisible2_e == 4) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_export_week", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        } else if (that.dialogVisible2_e == 5) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_export_one", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        } else if (that.dialogVisible2_e == 6) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_claim_num", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        }
     
    },
    haeDete(index, row) {     // 删除导航类别
      var that = this
      console.log(row)
      var ATT = that.Categ
      if (row.type == 'default') {
      } else {
        for (let i = 0; i < ATT.length; i++) {
          const ele = ATT[i];
          if (ele.id == row.id) {
            ATT.splice(index,1);
          }
        }
        that.Categ = ATT
      }
    },
    haeDete2(index, row) {     // 删除导航类别   --------------全部线索管理
      var that = this
      console.log(row)
      var ATT = that.Categ2
      if (row.type == 'default') {

      } else {
        for (let i = 0; i < ATT.length; i++) {
          const ele = ATT[i];
          if (ele.id == row.id) {
            ATT.splice(index,1);
          }
        }
        that.Categ2 = ATT
      }
    },
    Chang_ses(e) {           // 切换我的线索
      var that = this
      that.type_Self = e
      that.multipleSelection_id = null
      that.multipleSelection = []
      console.log(e) 
             let y1 =''
       let y2 =''
       
       if(that.Months1 != '') {
         y1 = that.formatDate(that.Months1);
       }
       if(that.Months2 != '') {
         y2 = that.formatDate(that.Months2);
       }
     
      axios({
        method: 'post',
        url: '/admin/customer/leads/index', 
        data: {
          page: 1,
          offset:0,
          limit:8,
          type: e,
          filter:{
            source_id: that.se_id,
            worth_id: that.wo_id,
            demand_id: that.de_id,
            time:{
              min:y1,
              max:y2,
            },
            keyword:that.input_seach
          }
        },
      }).then(function (res) {
        that.tableData = res.data.data.rows
        that.total1 = res.data.data.total
      })         
    },
    inpu_sech() {             // 搜索
      var that = this
             let y1 =''
       let y2 =''
       
       if(that.Months1 != '') {
         y1 = that.formatDate(that.Months1);
       }
       if(that.Months2 != '') {
         y2 = that.formatDate(that.Months2);
       }

      axios({
        method: 'post',
        url: '/admin/customer/leads/index', 
        data: {
          page: 1,
          offset:0,
          limit:8,
          type: that.type_Self,
          filter:{
            source_id: that.se_id,
            worth_id: that.wo_id,
            demand_id: that.de_id,
            time:{
              min:y1,
              max:y2,
            },
            keyword:that.input_seach
          }
        },
      }).then(function (res) {
        that.tableData = res.data.data.rows
        that.total1 = res.data.data.total
      })       
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
    },
    handleSelect_top (e) {
      if (e == 1) {
        this.$router.push('/Workbench/Manage');
      }else if (e == 2) {
        this.$router.push('/Workbench/Manage_2');
      } else if (e == 3) {
        this.$router.push('/Workbench/Manage_3');
      } else if (e == 4) {
        this.$router.push('/Workbench/Manage_4');
      }else if (e == 5) {
        this.$router.push('/Workbench/Manage_5');
      }
    },
    handleSelect(key, keyPath) {
      console.log(key);
      console.log(keyPath);
      if (key == 1) {
        this.info_Show = 0;
      } else {
        this.info_Show = 1
      }
    },
    changeSwitch(data,b,index) {      // 是否启用
      var that = this
    },
    Columns() {      //线索请求---------------------------------------------------------------------------------
      var that = this
        axios.get('/admin/customer/leads/statisticsColumns',{ 
          }).then(function (res) {
            if (res.data.code == 0) {
              that.$message.warning(res.data.msg);
            } else {
                that.leads_source = res.data.data.leads_source
                that.leads_worth = res.data.data.leads_worth
            }
        })      
    },
    UP_Success(e) {  //图片上传成功
      var that = this
      console.log(e)
      that.Row_Eurl.push(e.data.url)
      that.aTY = 0
      console.log(that.Row_Eurl)
    },
    UP_Success2(e) {  //图片上传成功
      var that = this
      console.log(e)
      that.Row_Eurl2.push(e.data.url)
      that.aTY = 0
      console.log(that.Row_Eurl2)
    },
    HAndemove(file, fileList) {
      var that = this
      that.Row_Eurl = []
        console.log(fileList)
        for (let i = 0; i < fileList.length; i++) {
          const element = fileList[i];
          that.Row_Eurl.push(element.response.data.url)
         
        }
        console.log(that.Row_Eurl)
    },
    HAndemove2(file, fileList) {
      var that = this
      that.Row_Eurl2 = []
        console.log(fileList)
        for (let i = 0; i < fileList.length; i++) {
          const element = fileList[i];
          that.Row_Eurl2.push(element.response.data.url)
         
        }
        console.log(that.Row_Eurl)
    },
    Btn_cj(e) {         // 线索添加  确认
      var that = this
      if (that.chakan111 == 1) {
        axios({
          method: 'post',
          url: '/admin/customer/leads/add', 
          data: {
            row:{
              type: that.type_Self,
              username: that.valueA_input1,
              mobile: that.valueA_input2,
              source_id:that.valueA_1,
              goods_ids:that.valueA_3,
              worth_id:that.valueA_2,
              description:that.valueA_input3,
              images:that.Row_Eurl,
              power:{
                staff_ids:that.valueA_4,
                department_ids:that.valueA_5,
              }
            }
          },
        }).then(function (res) {
          if (res.data.code == 0) {
            that.$message.warning(res.data.msg);
            console.log('qweqwe')
          }else {
            that.$message.success(res.data.msg);
            that.show1 = false
            that.AAAAA()  
          }
        
        })
      } else if (that.chakan111 == 0) {
        axios({
          method: 'put',
          url: '/admin/customer/leads/edit', 
          data: {
            id:that.Hand_id,
            row:{
              type: that.type_Self,
              username: that.valueA_input1,
              mobile: that.valueA_input2,
              source_id:that.valueA_1,
              goods_ids:that.valueA_3,
              worth_id:that.valueA_2,
              description:that.valueA_input3,
              images:that.Row_Eurl,
              power:{
                staff_ids:that.valueA_4,
                department_ids:that.valueA_5,
              }
            }
          },
        }).then(function (res) {
          if (res.data.code == 0) {
            that.$message.warning(res.data.msg);
            console.log('qweqwe')
          }else {
            that.$message.success(res.data.msg);
            that.show1 = false
            that.AAAAA()  
          }
        
        })
      }
       
    },
    handhange(e) {          // 勾选
      var that = this
      var arr = []
      var acc = []
      if (e.length == 0) {
        that.multipleSelection_id = null
      } else {
        for (let i = 0; i < e.length; i++) {
          const element = e[i];
          arr.push(element.id)
          acc.push(element)
        }
        that.multipleSelection_id = arr
      }
      that.multipleSelection = acc
    },
    HanDel(e, data) {       //单独删除
      var that = this 
      var arr = []
      arr.push(data.id)
      that.$confirm("确定要删除吗？", "提示", {
          type: "warning"
      }).then(() => {
            axios.delete('/admin/customer/leads/del',{ 
              params:{
                    ids: arr
              }
            }).then(function (res) {
            if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
            } else{ 
                that.$message.success(res.data.msg);
                that.AAAAA()
            }
          })            
      })     
    },
    Add_Del(e) {             //批量操作
        var that = this
        var Att = that.multipleSelection
        if (e == 1) {         
          console.log(e)        
          if (that.multipleSelection_id == null) {      //批量标记
            that.$message.warning('请勾选信息');
          } else {
            that.$confirm("确定要批量标记吗？", "提示", {
              type: "primary"
            }).then(() => {
              axios({
                method: 'post',
                url: '/admin/customer/leads/contact', 
                data: {
                  ids: that.multipleSelection_id
                },
              }).then(function (res) {
                that.$message.success(res.data.msg);
                that.show1 = false
                that.AAAAA()        
              })  
            })
          }
        } else if(e == 2) {           
          if (that.multipleSelection_id == null) {      //批量删除
            that.$message.warning('请勾选信息');
          } else {
            that.$confirm("确定要删除吗？", "提示", {
              type: "primary"
          }).then(() => {
            axios({
              method: 'delete',
              url: '/admin/customer/leads/del',
              data: {
                ids: that.multipleSelection_id
              },
            }).then(function (res) {
                if (res.data.code == 0) {
                  that.$message.warning(res.data.msg);
                } else {
                  that.$message.success(res.data.msg);
                  that.AAAAA()
                }
            }) 
          })
        }
        } else if (e == 3) {                             //批量升级
          if (that.multipleSelection_id == null) {  
            that.$message.warning('请勾选信息');
          } else {
            var auu = []
            that.editVisible = true
            that.Ta_Shsh = 0
            for (let i = 0; i < Att.length; i++) {
              const element = Att[i].username;
              auu.push(element)
            }
            that.TA_name1 = auu.toString()
          }

        } else if( e == 4) {
          if (that.multipleSelection_id == null) {      //批量退回
            that.$message.warning('请勾选信息');
          } else {
            that.$confirm("确定要批量退回吗？", "提示", {
              type: "primary"
          }).then(() => {
            axios({
              method: 'post',
              url: '/admin/customer/leads/callback', 
              data: {
                ids: that.multipleSelection_id
              },
            }).then(function (res) {
              that.$message.success(res.data.msg);
              that.show1 = false
              that.AAAAA()        
            })  
          })
            
          }
        } else if (e == 5) {
          if (that.multipleSelection_id == null) {      //批量认领
            that.$message.warning('请勾选信息');
          } else {
            that.$confirm("确定要批量认领吗？", "提示", {
              type: "primary"
          }).then(() => {
            axios({
              method: 'post',
              url: '/admin/customer/leads/claim', 
              data: {
                ids: that.multipleSelection_id
              },
            }).then(function (res) {
              that.$message.success(res.data.msg);
              that.show1 = false
              that.AAAAA()        
            })  
          })
            
          }          
        }
    },
    Handlbjjt(e, data) {              //单独标记
      var that = this 
      var arr = []
      arr.push(data.id)
      that.$confirm("确定要标记吗？", "提示", {
          type: "primary"
      }).then(() => {
        axios({
          method: 'post',
          url: '/admin/customer/leads/contact', 
          data: {
            ids:arr
          },
        }).then(function (res) {
          that.$message.success(res.data.msg);
          that.show1 = false
          that.AAAAA()        
        })             
      })     
    },

    HanEdit_SL(e, data) {              //单独认领
      var that = this 
      var arr = []
      arr.push(data.id)
      that.$confirm("确定要认领吗？", "提示", {
          type: "primary"
      }).then(() => {
        axios({
          method: 'post',
          url: '/admin/customer/leads/claim', 
          data: {
            ids:arr
          },
        }).then(function (res) {
          that.$message.success(res.data.msg);
          that.show1 = false
          that.AAAAA()        
        })             
      })     
    },
    saveEdit(e) {                 //身份升级确认
      var that = this
      var arr = []
      var acc = that.multipleSelection
      if (e == 1) {
        arr.push(that.TA_name1_Arr.id)
        axios({
          method: 'post',
          url: '/admin/customer/leads/upgrade', 
          data: {
            ids:arr,
            worth_id:that.Customer_Self
          },
        }).then(function (res) {
          that.$message.success(res.data.msg);
          that.editVisible = false
          that.AAAAA()
        })
      } else if(e == 2) {
        for (let i = 0; i < acc.length; i++) {
          const element = acc[i].id;
          arr.push(element)
        }
          axios({
            method: 'post',
            url: '/admin/customer/leads/upgrade', 
            data: {
              ids:arr,
              worth_id:that.Customer_Self
            },
          }).then(function (res) {
            that.$message.success(res.data.msg);
            that.editVisible = false
            that.AAAAA()
          })        
      }
       
    },
    Handlbc_TH(e, data) {            //点击退回
      var that = this 
      var arr = []
      arr.push(data.id)
      that.$confirm("确定要退回吗？", "提示", {
          type: "primary"
      }).then(() => {
        axios({
          method: 'post',
          url: '/admin/customer/leads/callback', 
          data: {
            ids:arr
          },
        }).then(function (res) {
          that.$message.success(res.data.msg);
          that.show1 = false
          that.AAAAA()        
        })             
      })  
    },
    HanEdit_SJ(e, data) {              //点击身份升级升级
      var that = this
      that.editVisible = true
      that.Customer_Self = ''
      that.TA_name1 = data.username
      that.TA_name1_Arr = data
      console.log(data)
      that.Ta_Shsh = 1
    },
    Handmuiksd(e) {
      var that = this
      var att = []
      console.log(e) 
      console.log(that.Case_attse)
      for (let i = 0; i < that.Case_attse.length; i++) {
        const element = that.Case_attse[i];
        att.push(element[1])
      }
      that.valueA_5 = att
      console.log(att)
    },
    Handmuiksd2(e) {
      var that = this
      var att = []
      console.log(e) 
      console.log(that.File_Bid)
      for (let i = 0; i < that.File_Bid.length; i++) {
        const element = that.File_Bid[i];
        att.push(element[1])
      }
      that.valueA_5 = att
      console.log(att)
    },
    AAAAA() {                                   ////////////////111111111111111111111111111111111111111111
      var that = this
        axios({
          method: 'post',
          url: '/admin/customer/leads/index', 
          data: {
            page: 1,
            offset:0,
            limit:10,
            type: that.type_Self,
          },
        }).then(function (res) {
          that.tableData = res.data.data.rows
          that.total1 = res.data.data.total
        })  
    },
    BBBBB() {
      var that = this
        axios.get('/admin/customer/config/statisticsColumns',{   // 设置选项 
              params:{
                type: 'leads'
              }
          }).then(function (res) {
            if (res.data.code == 0) {
              alert('请求失败');  
            } else{ 
                  that.Config1 = res.data.data.claim_day
                  that.Config2 = res.data.data.claim_one
                  that.Config3 = res.data.data.flow_min
                  that.Config4 = res.data.data.export_week
                  that.Config5 = res.data.data.export_one
                  that.Config6 = res.data.data.claim_num
                
            }
        })  
    },
    handleCurrentChange1(val) {    // 分页 ···············································
      var that = this
      console.log(val)
      that.currentPage1 = val
        axios({ 
          method: 'post',
          url: '/admin/customer/leads/index',   
            params:{
              page: val,
              limit:6,
              type: that.type_Self,
            }

        }).then(function (res) {
            if (res.data.code == 0) {
              that.$message.warning(res.data.msg);
            } else {
              that.tableData = res.data.data.rows
              that.total1 = res.data.data.total
            }

        }) 

    },
    formatDate(value) {    // 时间戳
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;

        return y + "-" + MM + "-" + d
    },
  },
};
</script>
<style>
.Spliiks .el-button{
    height: 26px!important;
    line-height: 2px;
    font-size: 11px;

}

.Spliiks .el-dropdown__icon {
  position: relative;
  top: -4px;
}
.Spliiks .el-dropdown__caret-button {
    height: 26px!important;
    line-height: 0px;
    top: 5px;
}
</style>

<style scoped> 


.Mang .tab_Bor .el-button:focus, .Mang .tab_Bor .el-button:hover {
  background-color: #fff;
  color: #262626;
}


</style>
